import {
  CreateBrandRequest,
  UpdateBrandImageRequest,
  UpdateBrandMetadataRequest,
} from './requests/brand-request.ts';
import {
  CreateBrandResponse,
  GetBrandImageResponse,
  GetBrandListResponse,
  GetBrandResponse,
  UpdateBrandImageResponse,
  UpdateBrandMetadataResponse,
} from './responses/brand-response.ts';
import { apiClient } from './client.tsx';

export const createBrand = (request: CreateBrandRequest) =>
  apiClient
    .post<CreateBrandResponse>('/v2/brands', request)
    .then((res) => res.data.data);

export const getBrand = (brandId: string) =>
  apiClient
    .get<GetBrandResponse>(`/v2/brands/${brandId}`)
    .then((res) => res.data.data);

export const getBrandList = () =>
  apiClient
    .get<GetBrandListResponse>('/v2/brands')
    .then((res) => res.data.data);

export const updateBrandMetadata = (request: UpdateBrandMetadataRequest) =>
  apiClient
    .put<UpdateBrandMetadataResponse>(`/v2/brands/${request.brandId}`, request)
    .then((res) => res.data.data);

export const updateBrandImage = async (request: UpdateBrandImageRequest) =>
  apiClient
    .post<UpdateBrandImageResponse>(
      `/v2/brands/${request.brandId}/images`,
      request.file,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data.data);

export const getBrandImage = (brandId: string, imageId: string) =>
  apiClient
    .get<GetBrandImageResponse>(`/v2/brands/${brandId}/images/${imageId}`)
    .then((res) => res.data.data);

export const removeBrand = (brandId: string) =>
  apiClient.delete(`/v2/brands/${brandId}`);
